<template>

  <div class="container">

    <nav aria-label="breadcrumb" class="mb-4 extra-small">
      <ol class="breadcrumb bg-white fw-bold">
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">{{$t('Inici')}}</router-link-locale></li>
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'organitzacions', params: {page: $route.params.listPage || 1, sort: $route.params.listSort || 'organitzacio_nom_ca asc'}}">{{$t('Organització')}}</router-link-locale></li>
        <li v-if="response.organitzacio" class="breadcrumb-item active" aria-current="page">{{ response.organitzacio[`organitzacio_nom_${locale}`] }}</li>
      </ol>
    </nav>

    <h1  class="d-flex justify-content-between">
      <span v-if="response.organitzacio && response.organitzacio[`organitzacio_nom_${locale}`]">{{ response.organitzacio[`organitzacio_nom_${locale}`] }}</span>
      <span v-else-if="response.assignatura">{{ response.organitzacio.organitzacio_nom_ca }}</span>
      <span class="text-secondary h5" style="position: relative; top: 15px;">Activitats<span class="badge rounded-pill badge-upc ms-2">{{materialCount}}</span> </span>
    </h1>

    <div class="row">

      <div class="col-sm-12 col-md-12">

        <div class="card rounded-0" v-if="response.organitzacio">

          <div class="card-body">

            <div class="m-t-20 row">
              <div class="col-md-2 col-xs-12 text-center mb-2">
                <img v-if="response.organitzacio.subtipus === 'centre' || response.organitzacio.subtipus === 'servei'" :src="require('@/assets/images/centres/'+response.organitzacio.id+'.jpeg')" alt="organitzacio" class="img-responsive img-thumbnail rounded-0">
                <div v-else ><i style="color: #5fa728;" class="fa-regular fa-building fa-8x mb-2"></i></div>
              </div>
              <div class="col-md-10">

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Nom')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{ response.organitzacio[`organitzacio_nom_${locale}`] }}

                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('tipus')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{ $t(response.organitzacio.subtipus) }}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Sigles')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    {{ response.organitzacio.organitzacio_sigles }}
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Adreça')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <a :href="'https://www.google.es/maps/engine/'+response.organitzacio.organitzacio_adreca" target="blank_">
                      {{response.organitzacio.organitzacio_adreca}}
                    </a>
                  </div>
                </div>

                <hr>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Localitat')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      {{response.organitzacio.organitzacio_localitat}}
                    </p>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">URL</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">
                      <a :href="response.organitzacio.organitzacio_web" target="blank_">
                        {{response.organitzacio.organitzacio_web}}
                      </a>
                    </p>
                  </div>
                </div>

                <hr v-if="response.organitzacio.organitzacio_titulacions_actives || response.organitzacio.organitzacio_titulacions_no_actives">

                <div class="row mb-2" v-if="response.organitzacio.organitzacio_titulacions_actives">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Titulacions Actives')}}</p></div>
                  <div class="col-md-9 col-xs-12 text-secondary">
                    <div v-for="titulacio in response.organitzacio.organitzacio_titulacions_actives" v-bind:key="titulacio.id">
                      <div class="mb-1">
                        <router-link :to="{name: 'titulacio', params: {id: titulacio}}">{{$t(titulacio)}}</router-link>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row mb-2" v-if="response.organitzacio.organitzacio_titulacions_no_actives">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Titulacions NO actives')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <div v-for="titulacio in response.organitzacio.organitzacio_titulacions_no_actives" v-bind:key="titulacio.id">
                      <div class="mb-1"><router-link :to="{name: 'titulacio', params: {id: titulacio}}">{{$t(titulacio)}}</router-link></div>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>

          <div class="card-footer">

              <div class="mt-1 mb-1 d-flex">
                <div class="d-flex ms-auto align-items-center">

                  <img src="../assets/images/mini-rss.svg" width="20" alt="user" class="me-1">
                  <a class="me-4" :href="'https://apren.upc.edu/api/RSS/' + response.organitzacio.id" target="_blank" rel="noreferrer noopener">{{$t('RSS')}}</a>

                </div>
              </div>
          </div>

        </div>

      </div>

    </div>

    <a @click='hideShowProfessorsFunction()' style="cursor:pointer;" class="text-secondary mr-1">
      <h2 class="mt-5">
        <i v-if="!hideShowProfessors" class="fa-regular fa-plus me-2"></i>
        <i v-if="hideShowProfessors" class="fa fa-minus me-2"></i>
        {{$t('participants')}}
      </h2>
    </a>

    <div v-if="hideShowProfessors">

      <div class="row">

        <div v-if="responseProfessors.length === 0" class="alert alert-danger rounded-0" role="alert">
          {{ $t("No results") }}
        </div>
        <div v-else class="col-sm-12 col-md-12">
          <ul class="list-unstyled" style="column-count: 4;">
            <!-- class="list-group-item list-group-item-action" style="border-bottom: none; border-top: none ; border-right: none; border-left: none;"-->
            <router-link v-for="(professor) in responseProfessors.professors" :key="professor.id" :to="{name: 'professor', params: {id: professor.id}}">
              <li class="mb-3"><i class="fas fa-user mr-2 text-secondary"></i> {{professor.professor_nom}} ({{professor.professor_num_activitats}})</li>
            </router-link>
          </ul>
        </div>

      </div>
    </div>


    <div class="row mt-4">
      <MaterialsCommon 
        :init-query="initQuery" 
        router-name="organitzacio" 
        @updateActivitatCount="handleActivitatCountUpdate" 
        :key="initQuery" 
        :show-treballs-finals="response.organitzacio?.subtipus === 'centre'"
        :center-id="$route.params.id"
        :year="2025"
      ></MaterialsCommon>
    </div>

  </div>

</template>

<script>

import {computed, nextTick, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import store from "@/store";
import {
  getProfessorsParticipantsOrganitzacio
} from "@/composables/pageFunctions";
import OrganitzacioService from "@/services/OrganitzacioService";
import { useI18n } from 'vue-i18n';
import {setMetadataName} from "@/composables/metadataFunctions";
import MaterialsCommon from "@/components/MaterialsCommon.vue";

  export default {
    name: "ProfessorsView",
    components: {
      MaterialsCommon,
      RouterLinkLocale
    },

    setup() {
      const { locale } = useI18n();

      const response = ref([]);
      const responseMaterials = ref([]);
      const responseProfessors = ref([]);
      const route = useRoute();

      const initQuery = computed(() => {
        const id = route.params.id;
        const subtipus = id.substring(0,1)
        let initQuery = ''

        if(subtipus === 'c' || subtipus === 's'){
          initQuery = `activitat_centres:${id}`
        }else if(subtipus === 'd'){
          initQuery = `activitat_departaments:${id}`
        }else if(subtipus === 'i'){
          initQuery = `activitat_instituts:${id}`
        }else{
          initQuery = `activitat_grups:${id}`
        }

        return initQuery
      });

      const materialCount = ref(0);

      const hideShowProfessors = ref(false)

      // Función para actualizar el estado con el número de materiales
      const handleActivitatCountUpdate = (count) => {
        materialCount.value = count
      };


      onMounted(async () => {
        await store.dispatch('updateSearchSelected', "Organització");
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-multicolor.webp') });
        const id = route.params.id;
        response.value = await OrganitzacioService.getOrganitzacio(id)
        setMetadataName(response.value.organitzacio[`organitzacio_nom_${locale.value}`])
      });


      const hideShowProfessorsFunction = async () => {
        if(responseProfessors.value.length === 0){
          responseProfessors.value = await getProfessorsParticipantsOrganitzacio(response.value.organitzacio.subtipus, response.value.organitzacio.id)
        }
        hideShowProfessors.value = !hideShowProfessors.value
      };

      watch(
          () => route.params.id,
          async (newId, oldId) => {
            if (newId !== oldId) {
              response.value = await OrganitzacioService.getOrganitzacio(newId)
              setMetadataName(response.value.organitzacio[`organitzacio_nom_${locale.value}`])

              const subtipus = newId.substring(0,1)
              //let initQuery = ''

              if(subtipus === 'c' || subtipus === 's'){
                initQuery.value = `activitat_centres:${newId}`
              }else if(subtipus === 'd'){
                initQuery.value = `activitat_departaments:${newId}`
              }else if(subtipus === 'i'){
                initQuery.value = `activitat_instituts:${newId}`
              }else{
                initQuery.value = `activitat_grups:${newId}`
              }

              //initQuery.value = initQuery


              await nextTick();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          },
          { immediate: true }
      );


      return {
        response,
        responseMaterials,
        responseProfessors,
        locale,
        initQuery,

        hideShowProfessors,
        hideShowProfessorsFunction,

        handleActivitatCountUpdate,
        materialCount
      }

    }


  }

</script>

<style scoped>
.card-body {
  position: relative;
  padding: 1.5rem; /* Optional: Adjust padding */
  color: #636363;
}

.card-body::before {
  content: "";
  position: absolute;
  top: 15px; /* Add margin from the top */
  right: 15px; /* Add margin from the right */
  bottom: 15px; /* Add margin from the bottom */
  left: auto; /* Add margin from the left */
  width: calc(50% - 25px); /* Occupies half of the card body minus the margins */
  height: calc(100% - 25px); /* Occupies full height minus the margins */
  background: url('../assets/images/fons_fitxa.png') no-repeat right center; /* Aligns background image to the right */
  background-size: contain;
  opacity: 0.8; /* Adjust the transparency as needed */
  z-index: 1;
}

.card-body * {
  position: relative;
  z-index: 2;
}

</style>
